export function isModifiedClick(event: React.MouseEvent): boolean {
  return (
    event.altKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.metaKey ||
    event.button > 0
  );
}
